import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDSnackbar from "components/MDSnackbar";
import styled from "styled-components";
import DatePicker from "react-multi-date-picker";
import { CircularProgress, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import KeepMountedModal from "components/Modal";
import { Link, Navigate } from "react-router-dom";
import { useMaterialUIController } from "context";
import TradingViewWidgetIbov from './TradingViewWidgetIbov';
import TradingViewWidgetSP500 from './TradingViewWidgetSP500';

const PRO_TIER = 3;

function Mercado() {
    const [controller, dispatch] = useMaterialUIController();
    const {
        userTier
    } = controller;
    const [isOpen, setIsOpen] = useState(false);
    const [allocationTarget, setAllocationTarget] = useState([]);
    const [currentAllocationTarget, setCurrentAllocationTarget] = useState([]);
    const [openSnackMessage, setOpenSnackMessage] = useState(null);


    // if (userTier != PRO_TIER){
    //    return <Navigate to="/pagamento" replace />
    // }


        return (
            <DashboardLayout>
                <DashboardNavbar />
                <MDBox pt={6} pb={3} >
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <StyledMDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="dark">
                                        IBOV
                                    </MDTypography>
                                </StyledMDBox>
                                <StyledDiv>
                                    <MDBox pt={4} pb={3} px={1} className="grafic">
                                        <TradingViewWidgetIbov />
                                    </MDBox>
                                </StyledDiv>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>

                <MDBox pt={6} pb={3} >
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <StyledMDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="dark">
                                        S&P 500
                                    </MDTypography>
                                </StyledMDBox>
                                <StyledDiv>
                                    <MDBox pt={4} pb={3} px={1} className="grafic">
                                        <TradingViewWidgetSP500 />
                                    </MDBox>
                                </StyledDiv>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
             
                <Footer />

                <Grid item xs={12} sm={6} lg={3}>
                    <MDSnackbar
                        color={openSnackMessage?.type}
                        icon="check"
                        title={openSnackMessage?.message}
                        open={openSnackMessage}
                        onClose={() => setOpenSnackMessage(false)}
                        close={() => setOpenSnackMessage(false)}
                    // bgWhite
                    />
                </Grid>
            </DashboardLayout>
        );
}

const StyledMDBox = styled(MDBox)`
  background: radial-gradient(circle at 221% 201%, #f28371 0%, #f28371 65%, transparent 0%) ,#f0ba8d !important; 
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: space-around;
    height: 600px;

    .grafic{
        width: 100%;
        display:flex;
        flex-direction: column;
        align-items: center;
    }
`;

const StyledDivButton = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 25px;
`;

export default Mercado;
